import ajax from './creatorAjax'
import request from '@/utils/request'
import { BASEURL, CPSURL } from '@/utils/appContent'

let base_url = BASEURL
let cps_url = CPSURL


// 埋点
export const burialPoint = async params => {
  return request({
    url: `https://monitor.eline56.com/monitor` + (base_url != 'https://gateway.eline56.com' ? '/test' : '') + params,
    method: 'get',
  })
}

// 获取 金额
export const getAccount = () => {
  return ajax(`${cps_url}/ccam/customs/getAccount`)
}

// 获取 头部数据
export const getMenubar = () => {
  return ajax(`${base_url}/services/menubar`)
}

export const checkAccountAmount = () => {
  return ajax(`${base_url}/services/company/checkAccountAmount`)
}

// 设置 余额不再提醒
export const setAmountWarn = () => {
  return ajax(
    `${base_url}/services/company/setAmountWarn`,
    {},
    {
      method: 'post'
    }
  )
}

// 获取用户信息
export const fetchUserInfo = () => {
  return ajax(`${base_url}/services/user/currentUser`)
}

// 获取产品开通状态信息
export const fetchProductOpenStatus = code => {
  return ajax(`${base_url}/services/product/status`, { code }, { method: 'get' })
}

// 判断是否需要去开通
export function checkProductOpenStatus(code) {
  return new Promise(resolve => {
    const resp = fetchProductOpenStatus(code)
    resolve(resp)
  })
}

// 获取公司认证信息
export const fetchCompanyApply = () => {
  return ajax(`${base_url}/services/company/currentCompany`)
}

// 获取公告列表
export const fetchNoticeList = async params => {
  return request({
    url: `${base_url}/services/notice/list`,
    method: 'get',
    params
  })
}

// 获取活动数据
export const activityOrderStatistic = async () => {
  return request({
    url: `${base_url}/services/recharge/activityOrderStatistic`,
    method: 'get'
  })
}

// 设置公告不再提醒
export const noMoreShowNotice = noticeId => {
  return ajax(
    `${base_url}/services/notice/setNoticeConfig`,
    { noticeId },
    {
      method: 'post'
    }
  )
}

// 更新提醒次数
export const updateNoticeConfig = messageId => {
  return request({
    url: `${base_url}/services/notice/${messageId}`,
    method: 'post'
  })
}

// 设置消息已读状态
export const fetchNoticeRead = (params, status) => {
  return request({
    url: `${base_url}/services/notice/message/${status}`,
    method: 'post',
    data: params
  })
}

// 设置消息已读状态
export const fetchProtocolRead = id => {
  return request({
    url: `${base_url}/services/notice/protocol/${id}`,
    method: 'post'
  })
}
// 查询企业可用余额用于提醒
export const fetchUseMoney = () => {
  return request({
    url: `${base_url}/services/notice/register`,
    method: 'get'
  })
}

// 获取Office
export const getWebOffice = url => {
  return request({
    url: `https://weboffice.cgofish.com/config?fileUrl=${encodeURIComponent(url)}`,
    method: 'get'
  })
}

///////////////////////////////////////////////////////////////////////////////////////////////

// 登入
export function login(data) {
  return request({
    url: `${base_url}/services/auth/login`,
    method: 'post',
    data
  })
}

// 获取产品列表
export function fetchProductList() {
  return request({
    url: `${base_url}/services/product/list`,
    method: 'get'
  })
}

// 获取邀请信息
export function fetchInviteInfo(inviteCode) {
  const res = request({
    url: `${base_url}/services/company/invite/${inviteCode}/info`,
    method: 'get'
  })
  if (res.code === 9) {
    res.msg = '当前用户已经存在企业，邀请链接无法使用哦 😊'
  }
  return res
}

// 加入企业
export function confirmInvite(inviteCode) {
  return request({
    url: `${base_url}/services/company/invite/${inviteCode}/confirm`,
    method: 'post'
  })
}
// 添加客户
export function addCrm(data) {
  return request({
    url: `${base_url}/services/openapi/store/addCrmInfo`,
    method: 'post',
    data
  })
}
